import { render } from "./ResetPassword.vue?vue&type=template&id=a8207f18&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=a8207f18&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a8207f18"

export default script